import { 
    BellOutlined, 
    HomeOutlined,
    DashboardOutlined } from '@ant-design/icons';
import { Badge, message, Button, Row, Col } from 'antd';
import CNF from '../../incs/Config';

const SYIcon = () => {
    return<>
            <div>
                <Row>
                    <Col span={6}>
                        <Button 
                            title='消息'
                            type='link'
                            onClick={() => {message.info('程序员跑路啦······', 1);}}>
                            <Badge dot>
                                <BellOutlined />
                            </Badge>
                        </Button></Col>
                    <Col span={6}><Button type='link' href={CNF.homeUrl} target='_blank' rel='noopener noreferrer' title='控制台'><HomeOutlined /></Button></Col>
                    <Col span={6}><Button type='link' href='/' rel='noopener noreferrer' title='仪表盘'><DashboardOutlined /></Button></Col>
                </Row>
            </div>
        </>
}

export default SYIcon;